export default __webpack_public_path__ + "static/media/riddler-quiz.93e5240d.jpg";